export default __webpack_public_path__ + "static/media/pc-setup.3becd87a.jpeg";